// extracted by mini-css-extract-plugin
export var container = "gV_c";
export var divider = "gV_h3";